import React, { useEffect, useState } from "react";
import CountUp from "react-countup";
import ajaxProject from "../../util/remote/ajaxProject";

export default function ProjectCard() {
  const [projectsNumber, setProjectsNumber] = useState(false);

  const getProjectsNumber = async () => {
    const server_response = await ajaxProject.fetchProjectNumber();

    if (server_response.status === "OK") {
      setProjectsNumber(server_response.details);
    } else {
      setProjectsNumber("404");
    }
  };

  useEffect(() => {
    getProjectsNumber();
  }, []);

  return (
    <div
      className="icon-box bg-color-6 d-block mt-4 mb-3"
      style={{
        background: "#EAEFFF",
        width: "22%",
        padding: "20px",
        margin: "15px 0 !important",
      }}>
      <div className="content text-center color-6">
        <h5
          className="title-box fs-17 font-w500"
          style={{
            fontWeight: "500",
            fontSize: "17px !important",
            lineHeight: "1.6",
          }}>
          Total Projects
        </h5>
        <div
          className="excellencetheme-counter fs-18 font-wb"
          style={{ fontWeight: "bold", color: "#496EE8" }}>
          <span
            className="number"
            data-from="0"
            data-to="309"
            data-speed="2500"
            data-inviewport="yes">
            <CountUp
              start={0}
              end={projectsNumber ? projectsNumber.total_p : "..."}
            />
          </span>
        </div>
      </div>
    </div>
  );
}
